import React from "react";
import PropTypes from "prop-types";
import { gettext } from "web/script/modules/django-i18n";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./back-button.css";

function BackButton({ onClick }) {
    return (
        <button onClick={onClick} className={styles.button} type="button">
            <SVGIcon name="chevron" rotate={180} />
            <span className={styles.title}>{gettext("general.back_btn_text")}</span>
        </button>
    );
}

export default BackButton;

BackButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};
